<template>
	<!-- 賬戶設定-員工帳戶設置 -->
	<div class="deal_index_box">
		<!-- 内容 -->
			<div class="deal_title">
				<div>賬戶設定<span>》</span><span>員工帳戶設置</span></div>
				<div class="deal_hr">
					<div class="cut_off"></div>
				</div>
			</div>
			<!-- 員工帳戶設置 -->
			<div class="deal_content_box">
				<div class="deal_content_title">權限設定</div>
				<!-- 權限設定 -->
				<div class="deal_content div_hight_end" >
					<img src="../../../../assets/img/user/04complaint_center.png" alt="" >
	
				</div>
			</div>
			<!-- deal_index_box -->
	</div>



</template>

<script>
    import axios from 'axios';
	export default {
		name: 'LoginDealIndex',
		data() {
            return{}
		},
		methods: {

		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	/* 表頭 */
	.deal_index_box {
		margin: 20px;
		font-size: 15px;
		color: black;
	}
    .deal_title {
    	display: flex;
    	justify-content: flex-start;
    	padding-bottom: 10px;
    }
    
    .deal_title span {
    	margin-left: 15px;
    	margin-right: 8px;
    }
    
    .deal_title .deal_hr {
    	flex: 1;
    	margin-left: 18px;
    }
    
    .deal_title .deal_hr .cut_off {
    	height: 3px;
    	background: black;
    	margin-top: 8px;
    }
	.deal_content_box {
		font-size: 13px;
		margin-top: 20px;
	}
	
	.deal_content_title {
		height: 42px;
		background: #666666;
		line-height: 42px;
		color: white;
		padding-left: 14px;
	}
	
	.deal_content {
		box-sizing: border-box;
		/* height: 53.6vw; */
		min-height: 100px;
		border: 1px solid #666666;
		background: #ffffff;
		padding: 30px;
		padding-top: 26px;
	}
	


</style>

